<template>
  <div class="columns is-multiline">
    <div class="column is-3" v-if="afficherCode">
      <b-field :label="$t('addEditFournisseurSupport.informationsGenerales.code')">
        <b-input disabled v-model="data.code"></b-input>
      </b-field>
    </div>
    <div class="column is-3" v-if="!isParticulier">
      <input-tier-nom-commercial
          :label="$t('addEditFournisseurSupport.informationsGenerales.raisonSociale')"
          v-model="data.nomCommercial"
          :tierId="data.id"
          :query="fournisseurQuery"
          path="c.presse.fournisseur_support">
      </input-tier-nom-commercial>
    </div>
    <div class="column is-3" v-if="isParticulier">
      <parametre-autocomplete
        :label="$t('addEditFournisseurSupport.informationsGenerales.civilite')"
        v-model="data.civiliteId"
        :target="constantes.PARAMETRES_KEYS.civilite"
        expanded
      />
    </div>
    <div class="column is-3" v-if="isParticulier">
      <b-field
        :label="$t('addEditFournisseurSupport.informationsGenerales.nom')"
        class="obligatoire">
        <b-input v-model="data.nom"></b-input>
      </b-field>
    </div>
    <div class="column is-3" v-if="isParticulier">
      <b-field :label="$t('addEditFournisseurSupport.informationsGenerales.prenom')">
        <b-input v-model="data.prenom"></b-input>
      </b-field>
    </div>
    <div class="column is-3">
      <input-email :label="$t('addEditFournisseurSupport.informationsGenerales.email')"
                   v-model="data.email"/>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditFournisseurSupport.informationsGenerales.telephoneFixe')">
        <b-input v-model="data.telephone"></b-input>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditFournisseurSupport.informationsGenerales.telephonePortable')">
        <b-input v-model="data.portable"></b-input>
      </b-field>
    </div>
    <div class="column is-3" v-if="!isParticulier">
      <b-field
        :label="$t('addEditFournisseurSupport.informationsGenerales.siret')">
        <b-input v-model="data.siret"></b-input>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditFournisseurSupport.informationsGenerales.applicationTva')">
        <b-select v-model="data.applicationTva" expanded>
          <option
            v-for="item in constantes.LISTE_APPLICATION_TVA"
            :value="item.code"
            :key="item.code">
            {{ $t(item.libelle) }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-narrow">
      <b-field class="has-text-default bfieldWhitoutLabel">
        <qd-checkbox v-model="data.interne">
          {{ $t('addEditFournisseurs.informationsGenerales.interne')}}
        </qd-checkbox>
      </b-field>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  LISTE_SOUS_TYPE_WITHOUT_BAILLEUR,
  TIERS_SOUS_TYPE_AFFICHEUR,
  TIERS_SOUS_TYPE_CONFRERE,
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
  LISTE_APPLICATION_TVA,
} from '@/configuration/tiers/tiersConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import inputEmail from '@/components/general/inputEmail';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import inputTierNomCommercial from '@/components/general/input/tierNomCommercialInput/tierNomCommercialInput';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    afficherCode: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      filteredTags: traductionLibelleEtat(this.$i18n, LISTE_SOUS_TYPE_WITHOUT_BAILLEUR),
      sousTypeFournisseurSupport: null,
      constantes: {
        LISTE_APPLICATION_TVA,
        PARAMETRES_KEYS,
      },
    };
  },
  components: {
    inputEmail,
    inputTierNomCommercial,
    parametreAutocomplete,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isParticulier() {
      return this.data.sousTypes.find((sousType) => {
        return sousType.code === TIERS_SOUS_TYPE_BAILLEUR_PRIVE;
      });
    },
    fournisseurQuery() {
      return {
        nomsCommercialOuNomsJuridique: [this.data.nomCommercial],
        societeId: this.societeActiveId,
        type: TIERS_TYPE_FOURNISSEUR,
        sousType: [TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT],
      };
    },
  },
  mounted() {
    this.sousTypeFournisseurSupport = this.data.sousTypes.find((sousType) => {
      return sousType.code !== TIERS_SOUS_TYPE_AFFICHEUR
        && sousType.code !== TIERS_SOUS_TYPE_CONFRERE;
    });
  },
};
</script>
